import type { IFromToRange } from '@src/@types/ranges';

const percentFormatter = new Intl.NumberFormat('ru-RU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});
const format = (v?: number, isPhone = false) => {
  if (v == null) return null;

  if (isPhone && v === 0) return '0';

  return percentFormatter.format(v);
};

export const getPskRange = (details: IFromToRange, isPhone: boolean) => {
  const min = format(details?.from, isPhone);
  const max = format(details?.to);

  if (min && max) {
    if (min === max) return `${min}%`; // если равны, показываем один
    return `${min} – ${max}%`;
  }

  if (min) return min;
  if (max) return `${format(0, isPhone)} – ${max}%`;
  return `${format(0, isPhone)}%`;
};
